// extracted by mini-css-extract-plugin
export const Pagination = "PostLIstTemplate-module--Pagination--10E98";